import {put, takeLatest, call} from 'redux-saga/effects';
import * as paymentService from "../../../services/paymentService";
import {
    PURCHASE_BY_PROVISION,
    PURCHASE_BY_PROVISION_SUCCESS,
    PURCHASE_BY_PROVISION_ERROR,
}
    from "../../actions/payment"

function* purchaseByProvisionSaga(action) {
    try {
       const data  = yield call(paymentService.PurchaseByProvision,action.payload)
       yield put({
        type: PURCHASE_BY_PROVISION_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: PURCHASE_BY_PROVISION_ERROR,error: error.data
        })
    }
}


export function* purchaseByProvisionSagaWatcher() {
    yield takeLatest(PURCHASE_BY_PROVISION, purchaseByProvisionSaga)
}